import { useEffect, useState } from "react";
import "./Navbar.scss";
import { Dropdown, Space, Modal, Button } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "../../../store/service/authService";
import ChangePassword from "../ChangePassword/ChangePassword";
import { MdMenu, MdOutlineRefresh } from "react-icons/md";
import SelfDeposit from "../DepositModal/SelfDeposit";
import { effectiveUserType, roleLabel } from "../../../utils/roles";
import { APP_BRAND_MARK, APP_BRAND_TAIL } from "../../../utils/brand";

const Navbar = ({ action }) => {
  const userData = localStorage.getItem("username") || "User";
  const userType = effectiveUserType();
  const displayName = userType === "7" && String(userData).toLowerCase().includes("system")
    ? "Super Admin"
    : userData;
  const initial = String(displayName).trim().charAt(0).toUpperCase() || "U";

  const [trigger] = useLogoutMutation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDepositeModalOpen, setIsDepositeModalOpen] = useState(false);
  const nav = useNavigate();

  const handleLogout = () => {
    trigger();
    localStorage.clear();
    nav("/");
  };

  const items = [
    ...(userType == "7"
      ? [
          {
            label: "Deposit",
            key: "2",
          },
        ]
      : []),
    {
      label: "Change Password",
      key: "0",
    },
    {
      label: <p onClick={handleLogout}>Logout</p>,
      key: "1",
    },
  ];

  const handleModal = (e) => {
    if (e.key == 0) {
      setIsModalOpen(true);
    } else if (e.key == 2) {
      setIsDepositeModalOpen(true);
    }
  };

  const handleCancel = () => {
    if ((pType == "old" || pType == "Old") && uType == "5") {
      setIsModalOpen(true);
    } else {
      setIsModalOpen(false);
    }
  };

  const pType = localStorage.getItem("passType");
  const uType = localStorage.getItem("userType");

  useEffect(() => {
    if ((pType == "old" || pType == "Old") && uType == "5") {
      setIsModalOpen(true);
    }
  }, [pType, uType]);

  return (
    <>
      <div className="nav">
        <div className="nav_left">
          <Space className="open_btn">
            <Button type="text" className="sub_open_btn" onClick={action}>
              <MdMenu />
            </Button>
          </Space>
          <div className="nav_brand" aria-hidden="true">
            <span className="bm_logo_mark">{APP_BRAND_MARK}</span>
            <span className="bm_brand_title">{APP_BRAND_TAIL}</span>
          </div>
        </div>

        <div className="nav_drop">
          <div className="sub_menu_nav">
            <Dropdown
              className="droup_nav"
              menu={{
                className: "nav_droupdown",
                items,
                onClick: handleModal,
              }}
              trigger={["click"]}>
              <button
                type="button"
                className="user_deatils"
                onClick={(e) => e.preventDefault()}>
                <span className="user_avatar" aria-hidden="true">
                  {initial}
                </span>
                <span className="user_meta">
                  <span className="user_deatils_text">{displayName}</span>
                  <span className="user_role">{roleLabel(userType)}</span>
                </span>
                <CaretDownOutlined className="user_deatils_icon" />
              </button>
            </Dropdown>

            <button
              type="button"
              className="nav_refresh_btn"
              title="Refresh"
              aria-label="Refresh"
              onClick={() => window.location.reload()}>
              <MdOutlineRefresh className="nav_refresh_icon" />
            </button>
          </div>
        </div>
      </div>

      <Modal
        className="change_pass"
        title="Change Password"
        open={isModalOpen}
        onCancel={handleCancel}
        destroyOnClose
        footer={false}>
        <div className="ch_pass">
          <ChangePassword setIsModalOpen={setIsModalOpen} />
        </div>
      </Modal>
      <SelfDeposit
        isDepositeModalOpen={isDepositeModalOpen}
        setIsDepositeModalOpen={setIsDepositeModalOpen}
      />
    </>
  );
};

export default Navbar;
